import React from "react";
import { Fragment } from "react";
// import { Link } from "react-router-dom";
import logo from "../../assets/images/landbook.png";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <div className="connection-timeout-page-land-book-logo">
            <img src={logo} alt="" />
          </div>
          <div className="connection-timeout-error">
            <h1 className="connection-timeout-error-title">
              Woops! <br />
              Something went wrong :(
            </h1>
            <h2 className="connection-timeout-error-subtitle">
              {/* Your session has expired! */}
            </h2>

            <a href="/login">Go back to home</a>
          </div>
        </>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
